module.exports = __webpack_public_path__ + "img/choose-01.3fc7bf00.png";